export const ru = {
    actionDisabled: 'Операция не доступна',
    'actions-title': 'Действия',
    aim: 'Нацелиться на объявление',
    bannerAimingDisabledMessage:
        'Нацеливание работает для запущенных кампаний и баннеров, прошедших модерацию',
    copy: 'Копировать',
    delete: 'Удалить',
    edit: 'Редактировать',
    editNoPermission: 'Недостаточно прав',
    'go-to-report-master': 'Перейти в Мастер отчетов',
    'internal-tool-title': 'Внутренние инструменты',
    moderate: 'Отправить на модерацию',
    moderateAccept: 'Подтвердить модерацию',
    moderateAcceptBannersAdditions: 'Модерация: принять уточнения',
    moderateByClient: 'Отправить на модерацию',
    notEditable: 'Редактирование недоступно',
    remoderate: 'Перемодерировать',
    remoderateBannersAdditions: 'Перемодерация уточнений',
    resume: 'Активировать',
    sendBK: 'Отправить в БК',
    suspend: 'Остановить'
};
